// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/jobportal-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  overflow-y: scroll;
}

body {
  padding-right: 0 !important;
}

button:hover {
  background-color: #CEE0F5 !important;
  border: 1px solid #CEE0F5 !important;
  color: #0851A3 !important;
}

.bg-all {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 126px;
}

.bg-trueblue {
  background-color: #0A65CC;
  color: #fff;
}

.bg-honeydew {
  background-color: #E8F7EA;
}

.color-trueblue {
  color: #0A65CC;
}

.color-slategray {
  color: #767F8C;
}

.color-blackcoral {
  color: #5E6670;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-center-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.rotate-270 {
  transform: rotate(270deg);
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/pages/publicRoute/JobPortal.scss"],"names":[],"mappings":"AAaA;EACE,kBAAA;AAZF;;AAeA;EACE,2BAAA;AAZF;;AAeA;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;AAZF;;AAeA;EACE,mDAAA;EACA,4BAAA;EACA,2BAAA;AAZF;;AAeA;EACE,yBAAA;EACA,WAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,yBAAA;AAZF","sourcesContent":["// $trueBlue: #0A65CC; // Button bg, icon color\n// $USAFABlue: #0851A3; // Button hover color\n// $cobaltBlue: #0A4FAE; // Filter button bg & color, Joblist border\n// $light: #F8F9FA; \n// $azureishWhite: #CEE0F5; // Button hover bg\n// $brightGray: #E7F6EA; // Badge bg\n// $northTexasGreen: #0BA02C; // Badge color\n// $slateGray: #767F8C; // Others\n// $manatee: #9199A3; // Search placeholder\n// $blackCoral: #5E6670; //Job desc\n// $white: #FFF;\n// $black: #000;\n\nhtml {\n  overflow-y: scroll;\n}\n\nbody {\n  padding-right: 0 !important;\n}\n\nbutton:hover {\n  background-color: #CEE0F5 !important;\n  border: 1px solid #CEE0F5 !important;\n  color: #0851A3 !important;\n}\n\n.bg-all {\n  background: url(../../assets/images/jobportal-bg.png);\n  background-repeat: no-repeat;\n  background-size: 100% 126px;\n}\n\n.bg-trueblue {\n  background-color: #0A65CC;\n  color: #fff;\n}\n\n.bg-honeydew {\n  background-color: #E8F7EA;\n}\n\n.color-trueblue {\n  color: #0A65CC;\n}\n\n.color-slategray {\n  color: #767F8C;\n}\n\n.color-blackcoral {\n  color: #5E6670;\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-center-column {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.rotate-270 {\n  transform: rotate(270deg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
